<template lang="pug">
    .store-page(v-if="user")
        .store-page-head(:style="backgroundHead")
        .store-page-title(:class="titleClass")
            .store-page-title__label Products
            .store-page-title__search-control
                search-control(v-model="search" placeholder="Search" @blur="closeSearch" @input="fetch")
            .store-page-title__search
                icon-button-control(iconId="search" @click="toggleSearch")
        .store-page-product-list(v-scroll-bottom="scrollBottom")
            .store-page-product-list__item(v-for="(product, key) in products" :key="key")
                .product-list-item__image(@click="goToProductPage(product)")
                    img(:src="getFirstImageUrl(product)" alt="")
                .product-list-item__description
                    .product-list-item-info
                        .product-list-item-info__title(@click="goToProductPage(product)") {{ product.title }}
                        .product-list-item-info__price ${{ product.price }}
                    .product-list-item-actions
                        .product-list-item-actions__shopping-cart(@click="addToCheckout(product)")
                            svg-icon(iconId="settings-store")
</template>

<script>
import UserProductsService from '../services/user-products-service'

export default {
    name: 'store-page',
    props: {
        username: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            user: null,
            products: [],
            pagination: {
                currentPage: 0,
                lastPage: 1,
                total: 0,
            },
            loaded: false,
            search: '',
            searchEnabled: false,
        }
    },
    computed: {
        backgroundHead() {
            return this.user.cover_image ?
                { 'background-image': 'url(' + this.user.cover_image + ')' } :
                { 'background-color': 'rgba(146, 152, 151, 0.3)' }
        },
        titleClass() {
            return {
                'store-page-title--search': this.searchEnabled,
            }
        },
        isLastPage() {
            return this.pagination.currentPage === this.pagination.lastPage
        },
    },
    async created() {
        const { data: { data: user } } = await axios.get(`/api/customer/user/username/${this.username}`)
        this.user = user
        await this.fetch()
    },
    methods: {
        async fetch() {
            if (this.loaded && this.isLastPage) {
                return
            }

            const { data } = await UserProductsService.get(this.user.id, {
                search: this.search,
                type: 'creator',
                is_active: 1,
            }, 'desc', this.pagination.currentPage + 1)

            if (this.loaded) {
                this.products.push(...data.data)
            } else {
                this.products = data.data
                this.loaded = true
            }

            this.pagination.currentPage = data.meta.pagination.current_page
            this.pagination.lastPage = data.meta.pagination.total_pages
            this.pagination.total = data.meta.pagination.total
        },
        addToCheckout(product) {
            this.$store.dispatch('Shop/Orders/Cart/addCartItem', {
                type: 'creator',
                payload: {
                    product_id: product.id,
                },
                attributes: {
                    product: product,
                },
                total: product.price,
            })

            this.$router.push({ name: 'shopping-cart-page' })
        },
        scrollBottom() {
            this.fetch()
        },
        getFirstImageUrl(product) {
            return product.images.data.length ? product.images.data[0].url : null
        },
        toggleSearch() {
            if (this.searchEnabled) {
                this.closeSearch(true)
            } else {
                this.searchEnabled = true
            }
        },
        goToProductPage(product) {
            this.$router.push({ name: 'store-product-page', params: { username: this.username, productId: product.id }})
        },
        closeSearch(clear) {
            if (clear) {
                this.search = ''
            }
            if (!this.search) {
                this.searchEnabled = false
            }
        },
    }
}
</script>
